import { Form, Select } from 'antd'

type SelectType = {
   name?: string
   className?: string
   step?: string
   isRequired?: boolean
   placeholder?: string
   dataTestId?: string
   pattern?: string
   disabled?: boolean
   errorMessage?: string
   options?: any
   multiple?: boolean
   value?: any
   defaultValue?: any
   label?: string
   tooltip?: string
   showSearch?: boolean
   formItemClassName?: string
   loading?: boolean
   allowClear?: boolean
   onChange?: (value: any) => void
   onPopupScroll?: (e: any) => void
}

export const SelectField: React.FC<SelectType> = ({
   name,
   className,
   isRequired,
   placeholder,
   errorMessage,
   options,
   defaultValue,
   dataTestId,
   disabled,
   value,
   label,
   tooltip,
   formItemClassName,
   showSearch,
   loading = false,
   allowClear = true,
   onChange,
   onPopupScroll,
}) => {
   const handleChange = (value: any) => {
      if (onChange) {
         onChange(value)
      }
   }

   const handlePopupScroll = (e: any) => {
      const target = e.target
      if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
         onPopupScroll?.(e)
      }
   }

   return (
      <Form.Item
         name={name}
         label={label}
         rules={[{ required: isRequired, message: errorMessage }]}
         tooltip={tooltip}
         className={formItemClassName}
      >
         <Select
            className={`${className}`}
            placeholder={placeholder}
            allowClear={allowClear}
            options={options}
            defaultValue={defaultValue}
            data-testid={dataTestId}
            disabled={disabled}
            onChange={handleChange}
            onPopupScroll={handlePopupScroll}
            showSearch={showSearch}
            loading={loading}
            value={value}
            filterOption={(input, option) =>
               (option?.label?.toString().toLowerCase() ?? '').includes(
                  input.toLowerCase()
               )
            }
         ></Select>
      </Form.Item>
   )
}
